var i18nLib = require("../i18n");
var aux = require("./__aux");
var Favorites = require("./favorite");

$(document).ready(function () {
	// Prevent old search feature on search results page
	var pathBuilder = [location.protocol, '', location.host];
	var searchPath;
	if ((searchPath = $('#searchPath').val())) {
		pathBuilder.push(searchPath);
	}
	var localSearchPath = pathBuilder.join('/');
	if (aux.clearUrlAnchor(aux.clearUrlQuery(location.href)) === aux.clearUrlAnchor(localSearchPath)) {
		$('.search-content-mobile').remove();
	}

	// Autocomplete
	var autocompleteEventCallback = aux.debounce(function (event) {
		var $this = $(this);
		var searchTerm = ($this.val() || '').trim();
		// Clear autocomplete when ESC is pressed or there are no searchTerm
		if (event.which === 27 /*ESC*/ || !searchTerm) {
			$this.val('');
			$('#searchForm').trigger('submitAsync');
		} else if (aux.isInputKey(event.which) && searchTerm.length > 2) {
			$('#searchForm').trigger('submitAsync');
		}
	}, 500);

	var changeEventsForMobile = function () {
		var isMobile = aux.isMobile();
		if (isMobile === window.isMobileSearch)
			return; // Prevent false-positives

		// Closing all search before resize layout changes
		$('section.search-content').removeClass('searchOpen');
		$('header .header__search').addClass('hidden');
		$('.as-nav').removeClass('mega-menu');
		$('.as-nav .menu').removeClass('hidden');
		$('.search-content-mobile #itemsResult').html('');
		$('.header__wrapper #searchTerm').val('');
		$('.search-content section.tour-themes').remove();
		$('.search-content .results, #search-results').removeClass('open');

		if (isMobile) {
			window.isMobileSearch = true;
			$('#search__link--autocomplete').attr('id', 'search-link');
			$('#search-link').off('click');
			$('#search-link').click(function () {
				$('section.search-content').addClass('searchOpen');
				$('.search-content-mobile #searchTerm').val('').trigger('focus');
			});
			$('#searchTerm').off('keydown');
			$('#searchTerm').keydown(autocompleteEventCallback);
			var tourThemes = $('<div><section  class="tour-themes">' +
				'    <div class="container">' +
				'        <div class="theme-categories">' +
				'            <div class="theme-categories--cards" id="tourResult">' +
				'            </div>' +
				'        </div>' +
				'    </div>' +
				'</section></div>');
			$('#searchTermPag').after(tourThemes.html());
		} else {
			window.isMobileSearch = false;
			$('#search-link').attr('id', 'search__link--autocomplete');
		}
	};
	changeEventsForMobile({ type: 'inline' });
	$(window).resize(aux.debounce(changeEventsForMobile, 100));

	$('.search-content-mobile .close--button').click(function () {
		$('section.search-content-mobile').removeClass('searchOpen');
		$('.as-nav').removeClass('mega-menu');
		$('.search-content-mobile #searchTerm').val('');
	});

	$('#loadmoreSearch').click(function (event) {
		var searchTerm = $("#searchTermPag").val();
		getSearchMobileData(searchTerm, true);
		$('#loadmoreSearch').trigger('blur');
		event.preventDefault();
	});

	$('#searchForm').on('submitAsync', function () {
		var searchTerm = aux.clearUrlAnchor($('#searchTerm').val()).trim();
		if (searchTerm) {
			$("#searchTermPag").val(searchTerm);
			$('#currentPage').val(0);
			if (window.isMobileSearch) {
				getSearchMobileData(searchTerm);
			} else {
				getSearchData(searchTerm);
			}
		}
	});

	$("body").on('click', '.btn-search', function () {
		$(this).closest("form").trigger('submitAsync');
	});

	if (window.initialParams && window.initialParams.query) {
		var searchKey = encodeURIComponent(window.initialParams.query || '');
		var currentPage = parseInt(window.initialParams.page) || 0;
		$('#searchTerm').val(searchKey);
		$('#currentPage').val(currentPage);
		$('#searchForm').trigger('submitAsync');
	}

	var $tourResult = $('#tourResult');
	var _dummy = $tourResult && $tourResult.on && $tourResult.on('loadMoreFinished', function (_e, data) {
		try {
			var searchExtraResults = data && data.response && $('<div>' + data.response + '</div>').find('#itemsResult') || [];
			if (searchExtraResults.length <= 0) // Nothing to append
				return;

			var $itemsResult = $('#itemsResult');
			if ($itemsResult.length === 0) {
				var cards = $("#toursList .theme-categories--cards");
				cards.after('<section id="itemsResult" class="search-result"></section>');
				$itemsResult = $('#itemsResult');
			}
			$itemsResult.append(searchExtraResults.html());
		} catch (e) {
			console.error(e);
		}
	});
	// Trigger it once page has been loaded
	var $itemsResult = $('#itemsResult');
	if (!window.isMobileSearch && $itemsResult.length > 0) {
		var data = $itemsResult.parent().html();
		$itemsResult.parent().remove();
		$tourResult.trigger('loadMoreFinished', { response: data });
	}

	function getSearchData (searchTerm) {
		var self = $('#tourResult');
		var currentPage = $("#currentPage").val();

		$.ajax({
			url: "_/service/no.seeds.as/searchService",
			type: "POST",
			dataType: 'html',
			data: { searchTerm: searchTerm, currentPage: currentPage }, // serializes the form's elements.
			success: function (data) {
				$('#tourResult').show();
				var $data = $('<div>' + data + '</div>');
				$('#tourResult').html($data.find('.tourListPart').first().html());
				var total = parseInt($data.find('#tourListPartTotal').val()) || 0;
				$('#searchResultsMsg').text(' ' + i18nLib.localize('search_has_results', [String(total)]) + '.');
				bLazy.revalidate();
			},
			error: function (xhr) {
				console.error(xhr.responseText);
			}
		}).then(function (data) {
			self.trigger('loadMoreFinished', { response: data });
		}).then(function (data) {
			var tourListCardsContainer = $("#tourResult.theme-categories--cards")
			// Global functions from js/authentic/exchangeCurrencies.js
			var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
			if (exchangeRateCurrency && tourListCardsContainer[0]) {
				window.switchExchangeRateCurrency(tourListCardsContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
			}

			Favorites.favoriteTourList();
		}).then(function (data) {
			setTimeout(function () {
				bLazy.revalidate();
			}, 2000);
		});

		aux.trySequentially({
			nTimes: 20, callback: function (success, failure) {
				setTimeout(function () {
					bLazy.revalidate();
					failure();
				}, 500);
			}
		});
	}

	function getSearchMobileData (searchTerm, pagination) {
		var currentPage = $("#currentPage").val();

		$.ajax({
			url: "_/service/no.seeds.as/searchMobileService",
			type: "POST",
			dataType: 'json',
			data: { searchTerm: searchTerm, currentPage: currentPage }, // serializes the form's elements.
			beforeSend: function (xhr) {
				$('.results').addClass('open');
				$('.results').html($('#global-spinner').html());
			},
			success: function (data) {
				$('.results').removeClass('open');
				var resultText = data.total + " results for <em>" + data.searchTerm + "</em>";
				var resultText = data.total + " " + i18nLib.localize("results for") + " <em>" + data.searchTerm + "</em>";
				var resultTour = getResultTour(data.tourList);
				var resultItem = getResultItem(data.itemList);
				var newCurrentPage = data.newCurrentPage;

				if (data.lastPage)
					$("#loadmoreSearch").hide();

				$("#currentPage").val(newCurrentPage);

				if (!$('div#search-results').hasClass('open')) {
					$('.search-results').toggleClass('open');
					$('.results').toggleClass('open');
				}

				if (pagination) {
					if (resultTour && resultTour.length > 0) {
						$('#tourResult').show();
						$('#tourResult').append(resultTour);
					} else {
						$('#tourResult').hide();
					}

					$('#itemsResult').append(resultItem);
				}
				else {
					$('.results').html(resultText);

					if (resultTour && resultTour.length > 0) {
						$('#tourResult').show();
						$('#tourResult').html(resultTour);
					} else {
						$('#tourResult').hide();
					}

					$('#itemsResult').html(resultItem);
				}
				bLazy.revalidate();
			},
			error: function (xhr) {
				$('.results').removeClass('open');
				$('.results').html('');
				console.log(xhr.responseText);
			}
		}).then(function (data) {
			var tourListCardsContainer = $("#tourResult.theme-categories--cards")
			// Global functions from js/authentic/exchangeCurrencies.js
			var exchangeRateCurrency = window.loadExchangeRateFromSession && window.loadExchangeRateFromSession()
			if (exchangeRateCurrency && tourListCardsContainer[0]) {
				window.switchExchangeRateCurrency(tourListCardsContainer[0], exchangeRateCurrency.from, exchangeRateCurrency.to, exchangeRateCurrency.rate)
			}

			Favorites.favoriteTourList();
		}).then(function (data) {
			setTimeout(function () {
				bLazy.revalidate();
			}, 2000);
		});

		aux.trySequentially({
			nTimes: 20, callback: function (success, failure) {
				setTimeout(function () {
					bLazy.revalidate();
					failure();
				}, 500);
			}
		});
	}

	function getResultTour (tourList) {
		var html = "";
		if (tourList && tourList.length > 0) {
			tourList.forEach(function (tour) {
				html +=
					'<div class="theme-card ' + tour.listClass + '">' +
					'<div class="theme-card--img">';


				if ((Array.isArray(tour.campaigns) && tour.campaigns.length > 0) || tour.tourTag) {
					// <div data-th-if="${not #lists.isEmpty(tour.campaigns)} or ${tour.tourTag}" class="tag-group">
					html +=
						'<div class="tag-group">'
					if (Array.isArray(tour.campaigns) && tour.campaigns.length > 0) {
						html +=
							'<div class="card-offer">' +
							'	<h4>' + (tour.campaigns[0].bandText1 || tour.campaigns[0].specialOffer) + '</h4>';

						if (tour.campaigns[0].bandText2) {
							html += '	<h5>' + tour.campaigns[0].bandText2 + '</h5>';
						}
						html += '</div>';
					}

					if (tour.tourTag) {
						'<div class="tou-tag">'
						'	<h5>' + tour.tourTag + '</h5>'
						'</div>'
					}
					html += '</div>';
				}



				if (tour.image)
					html += '<img class="b-lazy" src="' + tour.image_lazyLoad + '" data-src="' + tour.image + '" alt="' + tour.title + '">';

				html += '<div class="theme-card--text">' +
					'<div class="theme-card--title">' + tour.title + '</div>' +
					'<div class="theme-card--info">' +
					'<div class="duration">' +
					'<span class="cal-date-w--icon">' + tour.durationText + '</span>' +
					'</div>';
				if (tour.tourRelatedContent) {
					if (tour.tourRelatedContent.period && tour.tourRelatedContent.period.length > 0) {
						html += '<div class="season">' +
							'<span class="' + tour.tourRelatedContent.period[0].icon + '-w--icon">' + tour.periodsText + '</span>' +
							'</div>';
					}
					if (tour.tourRelatedContent.transportation && tour.tourRelatedContent.transportation.length > 0) {
						html += '<div class="transportation">';
						var first = true;
						tour.tourRelatedContent.transportation.forEach(function (o) {
							html += first ? '<span class="' + o.icon + '-w--icon">' + o.name : ', ' + o.name;
							first = false;
						});
						html += '</span></div>';
					}
				}
				html += '</div>' +
					'</div>' +
					'<a class="linkWrap" href="' + tour.url + '"></a>' +
					'</div>' +
					'<div class="theme-card--caption">' + '<a class="linkSearch" href="' + tour.url + '">';

				if (tour.offer) {
					html += '<span>' + tour.offer + '</span>';
				}
				if (tour.priceText) {
					html += '<span class="currency-value" data-original-price-text="' + tour.priceText + '">' + tour.priceText + '</span>';
				}
				html +=
					'</div></a>' +
					'</div>';
			});
		}
		return html;
	}

	function getResultItem (itemList) {
		var html = '';
		if (itemList && itemList.length > 0) {
			html =
				'<div class="container">' +
				'<div class="row">' +
				'<div class="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2 col-lg-8 col-lg-offset-2">' +
				' <div class="description">';
			itemList.forEach(function (item) {
				var titleItem = item.title ? item.title : '';
				var introItem = item.intro ? item.intro : '';
				var urlItem = item.url ? item.url : '';

				html += '<h2><a href="' + urlItem + '">' + titleItem + '</a></h2>' + introItem;
			});
			html += '</div>' +
				'</div>' +
				'</div>' +
				'</div>';
		}

		return html;
	}
})



// WEBPACK FOOTER //
// ./src/main/resources/assets/js/authentic/search.js